import { render } from "./CreateNewUserModal.vue?vue&type=template&id=6bc5f50c"
import script from "./CreateNewUserModal.vue?vue&type=script&lang=js"
export * from "./CreateNewUserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__